import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import ApiConfig from '../../config/ApiConfig';
import Axios from 'axios';
import { Box, FormControl, Grid, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';

const useStyles = makeStyles({

})
function BarChart() {
  const classes = useStyles();
  const [options, setOptions] = useState({
    chart: {
      height: 350,
      type: 'line',
      zoom: {
        enabled: false
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [5, 5, 5, 5],
      curve: 'straight',
      dashArray: [0, 0, 0, 0]
    },
    title: {
      align: 'left'
    },
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + ''
      }
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6
      }
    },
    xaxis: {
      categories: [],
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              return val + " users"
            }
          }
        },
        {
          title: {
            formatter: function (val) {
              return val + " users"
            }
          }
        },
        {
          title: {
            formatter: function (val) {
              return val + " users";
            }
          }
        },
        {
          title: {
            formatter: function (val) {
              return val + " users";
            }
          }
        }
      ]
    },
    grid: {
      borderColor: '#f1f1f1',
    },
  });
  
  const [data, setData] = useState([])
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [allDates, setAllDates] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  // Helper function to format date to epoch time
  const formatDateToEpoch = (date) => {
    if (!date) return null;
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate.getTime();
  };

  const MulitData = async () => {
    try {
      setLoading(true);
      
      // Calculate epoch times
      const epochFrom = formatDateToEpoch(fromDate);
      const epochTo = toDate ? new Date(toDate).setHours(23, 59, 59, 599) : null;

      const res = await Axios({
        method: "GET",
        url: ApiConfig.chartStatus,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          fromDate: epochFrom,
          toDate: epochTo,
        },
      });

      if (res.data.status === 200) {
        const inputData = res?.data?.data?.roleCounts;
        console.log("API Response:", inputData);
        
        // Get all unique dates from all roles
        const datesSet = new Set();
        Object.values(inputData).forEach(roleData => {
          Object.keys(roleData).forEach(date => datesSet.add(date));
        });
        
        // Convert to array and sort chronologically
        const sortedDates = Array.from(datesSet).sort((a, b) => new Date(a) - new Date(b));
        
        // Store all dates for future reference
        setAllDates(sortedDates);
        
        // Set default fromDate to the earliest date if not already set
        if (!fromDate && sortedDates.length > 0) {
          const earliestDate = new Date(sortedDates[0]);
          setFromDate(earliestDate);
        }
        
        // Set default toDate to the latest date if not already set
        if (!toDate && sortedDates.length > 0) {
          const latestDate = new Date(sortedDates[sortedDates.length - 1]);
          setToDate(latestDate);
        }

        // Filter dates based on selected range
        let filteredDates = sortedDates;
        if (fromDate && toDate) {
          filteredDates = sortedDates.filter(date => {
            const currentDate = new Date(date);
            return currentDate >= new Date(fromDate) && currentDate <= new Date(toDate);
          });
        }

        // Format dates for display
        const formattedDates = filteredDates.map(date => {
          const d = new Date(date);
          return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
        });

        // Create series data for each role
        const seriesData = [
          {
            name: "Area Manager",
            data: filteredDates.map(date => inputData.BranchHead[date] || 0)
          },
          {
            name: "Regional Manager",
            data: filteredDates.map(date => inputData.BranchManager[date] || 0)
          },
          {
            name: "Administrator",
            data: filteredDates.map(date => inputData.HO[date] || 0)
          },
          {
            name: "Tester",
            data: filteredDates.map(date => inputData.Tester[date] || 0)
          }
        ];

        setOptions(prevOptions => ({
          ...prevOptions,
          xaxis: {
            ...prevOptions.xaxis,
            categories: formattedDates,
          }
        }));

        setData(seriesData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    MulitData();
  }, [fromDate, toDate]);
  return (
    <div id="chart">
      <Grid container xs={12} justifyContent='flex-end' style={{ gap: "10px", marginTop: "-40px" }}>
        <Grid item xs={12} sm={6} md={6} lg={3}>


          <div className={classes.forminputDate}>
            <KeyboardDatePicker
              className={classes.date}
              InputProps={{
                className: classes.TextBox,
              }}
              // placeholder="DD/MM/YYYY"
              InputLabelProps={{ shrink: true }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
              label='From Date'
              inputVariant="outlined"
              disableFuture
              margin="dense"
              name="dateOfBirth"
              value={fromDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                style: { marginRight: '-15px' },
              }}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>


          <div className={classes.forminputDate}>
            <KeyboardDatePicker
              className={`${classes.date} textFeilds`}
              InputProps={{
                className: classes.TextBox,
              }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
              label='To Date'
              InputLabelProps={{ shrink: true }}
              inputVariant="outlined"
              minDate={fromDate ? fromDate : new Date()}
              disableFuture
              margin="dense"
              name="dateOfBirth"
              value={toDate}
              onChange={handleToDateChange}
              KeyboardButtonProps={{
                style: { marginRight: '-15px' },
              }}
            />{" "}
          </div>
        </Grid>
        {/* <FormControl >
          <Select
            open={open1}
            onClose={handleClose1}
            onOpen={handleOpen1}
            value={usertype}
            onChange={(event) => {
              handleChange(event);
            }}
          >
            <MenuItem value="week">Weekly</MenuItem>
            <MenuItem value="month">Monthly</MenuItem>
            <MenuItem value="year">Yearly</MenuItem>
          </Select>
        </FormControl> */}
      </Grid>

      {data[0]?.data?.length == 0 && data[1]?.data?.length == 0 && data[2]?.data?.length == 0 && data[3]?.data?.length == 0 ? (<Box style={{ height: "350px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}> <Typography variant="h5"
        color="textSecondary" style={{ display: "flex", justifyContent: "center", alignItems: "center", color: '#6E6E6E', fontFamily: 'poppins' }} >No Data Found</Typography>  </Box>) : <ReactApexChart options={options} series={data} type="line" height={350} />}

    </div>
  );
}

export default BarChart;
